import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, addDays } from 'date-fns';

const DeliveryPickupStep = ({ formData, handleInputChange, errors }) => {
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (formData.rentalStartDate) {
      setStartDate(new Date(formData.rentalStartDate));
    }
  }, [formData.rentalStartDate]);

  const handleDateChange = (date) => {
    setStartDate(date);
    handleInputChange({
      target: {
        name: 'rentalStartDate',
        value: format(date, 'yyyy-MM-dd')
      }
    });
  };

  const calculateEndDate = () => {
    if (startDate && formData.rentalDuration) {
      return format(addDays(startDate, parseInt(formData.rentalDuration)), 'yyyy-MM-dd');
    }
    return '';
  };

  return (
    <div className="space-y-6">
      <div>
        <label htmlFor="rentalStartDate" className="block text-sm font-medium text-gray-700">
          Rental Start Date
        </label>
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          dateFormat="yyyy-MM-dd"
          minDate={new Date()}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
          required
        />
        {errors.rentalStartDate && <p className="text-red-500 mt-1">{errors.rentalStartDate}</p>}
      </div>

      <div>
        <label htmlFor="rentalDuration" className="block text-sm font-medium text-gray-700">
          Rental Duration (in days)
        </label>
        <input
          type="number"
          id="rentalDuration"
          name="rentalDuration"
          value={formData.rentalDuration}
          onChange={handleInputChange}
          min="1"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
          required
        />
        {errors.rentalDuration && <p className="text-red-500 mt-1">{errors.rentalDuration}</p>}
      </div>

      {startDate && formData.rentalDuration && (
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Rental End Date
          </label>
          <p className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-50">
            {calculateEndDate()}
          </p>
        </div>
      )}

      <div>
        <label htmlFor="deliveryInstructions" className="block text-sm font-medium text-gray-700">
          Delivery Instructions
        </label>
        <textarea
          id="deliveryInstructions"
          name="deliveryInstructions"
          value={formData.deliveryInstructions}
          onChange={handleInputChange}
          rows="3"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
        ></textarea>
        {errors.deliveryInstructions && <p className="text-red-500 mt-1">{errors.deliveryInstructions}</p>}
      </div>
    </div>
  );
};

DeliveryPickupStep.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default DeliveryPickupStep;